import { makeAutoObservable, runInAction } from 'mobx';
import { authApi } from '@helpers/AxiosHelper';

import * as yup from 'yup';

const SMS_ALARM_URL = '/api/alarm/sms';

export const initial = {
  smsAlarmList: {
    data: [],
    pageable: {
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 0,
    },
  },
  smsAlarm: {
    alarmSeq: 0,

    groupSeCode: null,
    sndngPrventSeqs: [], // 미사용
    sndngTrgetMemberSeqs: [], // 미사용

    sndngTargetRequests: [], // 발송대상 - 실제 api전달 필드
    sendTargetEnterpriseSeqs: [], // 발송대상 - 1dpeth
    sendTargetEngineerSeqs: [], // 발송대상 - 2depth

    sndngSe: null, // 발송시기
    sndngDateTime: null,
    sndngDate: null, // 발송날짜
    sndngTime: null, // 발송시간
    sj: '', // 제목
    cn: '', // 내용

    sndngDt: '',
    sndngPrventNm: '',
    sndngTrgetMemberNm: '',
  },
};

export const smsAlarmValidationSchema = yup.object({
  sj: yup.string().required('제목은 필수 입력 항목 입니다.'),
  cn: yup.string().required('내용은 필수 입력 항목 입니다.'),
});

export function createSmsAlarmStore() {
  return makeAutoObservable({
    smsAlarmList: initial.smsAlarmList,
    alarm: initial.smsAlarm,

    // 코드값
    headOfficeList: [],
    centerList: [],
    customerList: [],
    engineerList: [],

    sndngTargetList: null, // 발송대상 목록

    alertMessage: '',

    async getAlarmList(options) {
      try {
        const res = await authApi.get(
          SMS_ALARM_URL,
          {
            ...options,
          },
          null,
        );

        runInAction(() => {
          this.smsAlarmList = res;
        });

        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getAlarm(alarmSeq) {
      try {
        const { data } = await authApi.get(
          `${SMS_ALARM_URL}/${alarmSeq}`,
          null,
          null,
        );
        runInAction(() => {
          this.alarm = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async sendAlarm({
      cn, // 내용
      groupSeCode, // 그룹구분코드(1:전체, 2:본사, 3:고객사, 4:대리점(센터), 5:엔지니어)
      sj, // 제목
      sndngDate, // 발송날짜(날짜)
      sndngSe, // 발송시기(구분) (1:즉시, 2:예약)
      sndngTime, // 발송날짜(시간)
      sndngTargetRequests, // 발송대상
    }) {
      try {
        await authApi.post(SMS_ALARM_URL, {
          cn,
          groupSeCode,
          sj,
          sndngDate,
          sndngSe,
          sndngTime,
          sndngTargetRequests,
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    // 본사 직원
    async getHeadOffice() {
      try {
        const { data } = await authApi.get(
          `${SMS_ALARM_URL}/support/head-office`,
          null,
          null,
        );

        runInAction(() => {
          this.headOfficeList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getCenterList() {
      try {
        const { data } = await authApi.get(
          `${SMS_ALARM_URL}/support/center`,
          null,
          null,
        );

        runInAction(() => {
          this.centerList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getCustomerList() {
      try {
        const { data } = await authApi.get(
          `${SMS_ALARM_URL}/support/customer`,
          null,
          null,
        );

        runInAction(() => {
          this.customerList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getEngineerList(centerSeq) {
      try {
        const { data } = await authApi.get(
          `${SMS_ALARM_URL}/support/engineer`,
          { centerSeq },
          null,
        );

        runInAction(() => {
          this.engineerList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getSdndngTarget(groupSeCode) {
      try {
        const { data } = await authApi.get(
          `${SMS_ALARM_URL}/support/sndng-target`,
          {
            groupSeCode,
          },
        );

        runInAction(() => {
          this.sndngTargetList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    getAlertMessage() {
      const alertMessage = this.alertMessage;

      runInAction(() => {
        this.alertMessage = '';
      });

      return alertMessage;
    },
  });
}
